import React, { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const TEASER_TEXT =
  'Subject to non-deduction of insurance premium upon expiry of the BIMA ASBA mandate, I authorize deduction of a sum payable ';
const CONTINUATION_TEXT =
  'towards insurance premium to the insurer using autodebit, post the insurance decision is communicated to me. I further authorize payment of renewal insurance premium to the insurer as and when it is due through the registered autodebit.';
const FULL_CONSENT_TEXT = `${TEASER_TEXT} ${CONTINUATION_TEXT}`;

export default function RecurringAutodebitConsentFooter() {
  const [consentExpanded, setConsentExpanded] = useState(false);

  const consentToggleKeyDown = (expand) => (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setConsentExpanded(expand);
    }
  };

  return (
    <div className="upi-otm-consent recurring-autodebit-consent">
      <FormControlLabel
        control={
          <Checkbox
            checked
            disabled
            tabIndex={-1}
            inputProps={{ 'aria-readonly': true }}
            sx={{
              alignSelf: 'flex-start',
              mt: '-2px',
              '&.Mui-disabled': { color: '#0065FF' },
            }}
          />
        }
        label={
          <span className="upi-otm-consent-text">
            {!consentExpanded ? (
              <>
                {TEASER_TEXT}{' '}
                <span
                  role="button"
                  tabIndex={0}
                  className="upi-otm-consent-toggle-text"
                  aria-expanded={false}
                  onClick={(e) => {
                    e.preventDefault();
                    setConsentExpanded(true);
                  }}
                  onKeyDown={consentToggleKeyDown(true)}
                >
                  <strong className="upi-otm-consent-toggle-text-label">See more</strong>
                  <FaChevronDown aria-hidden size={12} />
                </span>
              </>
            ) : (
              <>
                {FULL_CONSENT_TEXT}
                {'\u00a0'}
                <span
                  role="button"
                  tabIndex={0}
                  className="upi-otm-consent-toggle-text"
                  aria-expanded
                  onClick={(e) => {
                    e.preventDefault();
                    setConsentExpanded(false);
                  }}
                  onKeyDown={consentToggleKeyDown(false)}
                >
                  <strong className="upi-otm-consent-toggle-text-label">See less</strong>
                  <FaChevronUp aria-hidden size={12} />
                </span>
              </>
            )}
          </span>
        }
        sx={{ alignItems: 'flex-start', marginLeft: 0, marginRight: 0 }}
      />
    </div>
  );
}
